
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/mapa-zjazdoviek",
      function () {
        return require("private-next-pages/[region]/[resort]/mapa-zjazdoviek.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/mapa-zjazdoviek"])
      });
    }
  